/**
 * 高德 JS API 2.0 动态装载。
 *
 * Key 走构建期环境变量(VITE_AMAP_KEY / VITE_AMAP_SECURITY_CODE,前端 JS Key ≠ 后端 Web 服务 Key,
 * 后者严禁进前端)。缺 Key / 加载失败一律 resolve null —— 地图区降级成占位说明,搜索与列表功能不受影响
 * (定稿 V1.1:key 未申请期间照常开发联调)。
 *
 * ★部署注意:console 生产/测试域的边缘 nginx 是严格 CSP(script-src 'self'),上线前必须给
 *   webapi.amap.com(script-src)与 restapi.amap.com、*.amap.com(connect-src/img-src)开白名单,
 *   否则脚本被 CSP 拦下、本函数永远走降级分支 —— 和 GEO 外链卡同款「服务端手工配置,不随代码走」。
 */

interface AmapWindow extends Window {
  AMap?: unknown;
  _AMapSecurityConfig?: { securityJsCode: string };
}

let pending: Promise<unknown | null> | null = null;

export function amapConfigured(): boolean {
  return Boolean(import.meta.env.VITE_AMAP_KEY);
}

export function loadAmap(): Promise<unknown | null> {
  const w = window as unknown as AmapWindow;
  const key = import.meta.env.VITE_AMAP_KEY as string | undefined;
  if (!key) return Promise.resolve(null);
  if (w.AMap) return Promise.resolve(w.AMap);
  if (!pending) {
    const security = import.meta.env.VITE_AMAP_SECURITY_CODE as string | undefined;
    if (security) {
      w._AMapSecurityConfig = { securityJsCode: security };
    }
    pending = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = `https://webapi.amap.com/maps?v=2.0&key=${encodeURIComponent(key)}`;
      s.async = true;
      s.onload = () => resolve(w.AMap ?? null);
      s.onerror = () => {
        pending = null; // 网络抖动后允许下次重试
        resolve(null);
      };
      document.head.appendChild(s);
    });
  }
  return pending;
}
